import { JSX } from 'preact'

interface Props extends Omit<JSX.HTMLAttributes<HTMLUListElement>, 'class' | 'className'> {
    terms?: { term: string }[]
    inputValue?: string
    isEmpty?: boolean
}

export default function SuggestionsTermList({
    terms,
    title,
    inputValue,
    isEmpty,
    ...ulProps
}: Props) {
    return (
        <div class='flex flex-col w-full'>
            <span class='font-extrabold font-lato mb-1 lg:mb-4 text-neutral-1 hidden lg:block'>
                {isEmpty ? 'Buscas Sugeridas' : 'Categorias'}
            </span>
            {inputValue === undefined && (
                <span class='font-extrabold font-lato mb-1 lg:mb-4 text-neutral-1 block lg:hidden'>
                    Buscas Sugeridas
                </span>
            )}
            <ul {...ulProps} class='flex flex-col gap-1'>
                {terms?.map(({ term }) => (
                    <li>
                        <a
                            href={`/s?q=${inputValue ? `${inputValue} ${term}` : term}`}
                            class='items-center block hover:underline transition-all'
                        >
                            <strong class='text-sm text-neutral-1'>{inputValue}</strong>
                            {inputValue && <span class='text-sm text-neutral-1 px-1'>em</span>}
                            <span class='text-sm text-neutral-1'>{term}</span>
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    )
}
